/*
 * @Author: bbqin
 * @Date: 2022-11-07 17:31:38
 * @LastEditTime: 2023-03-17 16:37:58
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Form\components\icon\infoGroupHeader.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';

export default function InfoGroupHeader(props) {
    let { color, title, icon, ...others } = props;
    return <div className={`form-info-group-header color-${color}`} title={title}>
        <div className='form-info-group-header-left'>
            {icon && <div className="form-info-group-icon" ><img src={icon} alt="图标" /></div>}
            <div className="form-info-group-title" >
                {title}
            </div>
        </div>
        <div className='form-info-group-header-right'>
            <div className="form-info-group-header-bg" >
            </div>
            <div className="form-info-group-header-bbg" >
                <div className="form-info-group-header-bg-left"></div>
                <div className="form-info-group-header-bg-right"></div>
            </div>
        </div>
    </div>;
}